import { useState } from "react"
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"
import AttributesManagementOverview from "../../../../components/AdminPortalComponents/AttributesManagement/AttributesManagementOverview/AttributesManagementOverview"
import BulkUpload from "../../../../components/AdminPortalComponents/AttributesManagement/BulkUpload/BulkUpload"

const AttributesManagement = () => {

  const tabs = [
    { key: 'attributeManagement', label: 'Attribute Management' },
    { key: 'bulkUpload', label: 'Bulk Upload' },
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].key)



  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f2f2f2", padding: "1rem" }}>
      <div className="shadow">
        <DynamicSquaredFilterBar tabs={tabs} setActiveTab={setActiveTab} activeTab={activeTab} barType="white" />
      </div>

      {activeTab === 'attributeManagement' && <AttributesManagementOverview /> }      
      {activeTab === 'bulkUpload' && <BulkUpload /> }      
    </div>
  ) 
}

export default AttributesManagement
